import LOGO from "../../2025_mens_a/images/UT.png";

export const Team__UTPaquime = {
  name: "UT Paquime",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#18ffc5ff",
  teamJerseyColor: "#0E293D",

  // Stats
  gamesWon: 3,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 12 + 28 + 21 + 26,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 26 + 29 + 25 + 24,
    },
  ],
};
